/**
 * @param {HTMLElement} element Target element to check and scroll to
 * @param {number} offset Optional offset from the top (default: 0)
 * @return {void}
 */
const scrollIntoViewIfNeeded = (element, offset = 0) => {
    const elementTop = element && element.getBoundingClientRect().top;
    const viewportTop = window.scrollY;
    const viewportBottom = viewportTop + window.innerHeight;

    if (elementTop < viewportTop || elementTop > viewportBottom) {
        window.scrollTo({
            top: offset,
            behavior: 'smooth'
        });
    }
};

const onCheckoutAddToCart = function () {
    const cartEl = document.getElementById('checkout-cart');
    if (!cartEl) return;

    const headerEl = document.querySelector('header.header');

    scrollIntoViewIfNeeded(cartEl, headerEl.offsetHeight / 2);
};

document.addEventListener('checkoutAddToCart', onCheckoutAddToCart);
